import React from 'react';
import { Layout, Title } from 'app/blocks/blocks';
import { ID, withCodes2 } from 'app/blocks/common/codes';
import { compose } from 'app/blocks/common/utils';
import withConfirmLeaving from 'app/blocks/common/withConfirmLeaving';
import PageBreadcrumbs from 'app/blocks/page/__breadcrumbs/page__breadcrumbs';
import OrdersOAConfirmation from 'app/pages/orders/confirmation';
import OrdersOAInitiate from 'app/pages/orders/oa/initiate';
import OrdersOAReview from 'app/pages/orders/oa/review';
import { confirmLeave } from 'app/pages/orders/oa/utils';
import OrdersOAPayment from 'app/pages/orders/payment';
import OpenAccessOrderContext, { OpenAccessOrderStepEnum, useOpenAccessOrderFlow } from './OpenAccessOrderContext';

function OrdersOA({ setChangesChecker }) {
    const { action, breadcrumbs, isLoading, isTimeout, order, orderChanged, onConfirmSubstep, onSaveForLater } =
        useOpenAccessOrderFlow();

    const onLeave = React.useCallback(
        async allowRedirect => {
            allowRedirect(
                await confirmLeave(OpenAccessOrderStepEnum, action, order?.existing, onSaveForLater, isTimeout),
            );
        },
        [action, order?.existing, onSaveForLater, isTimeout],
    );

    React.useEffect(() => {
        setChangesChecker(() => action === OpenAccessOrderStepEnum.REVIEW || orderChanged(), onLeave);
    }, [action, orderChanged, setChangesChecker, onLeave]);

    return (
        <div className="container">
            <Title>Open Access Payment</Title>

            <Layout isLoading={isLoading}>
                <div className="m-btm_md">
                    <PageBreadcrumbs action={action} breadcrumbs={breadcrumbs} />
                </div>

                {!isLoading && (
                    <>
                        {action === OpenAccessOrderStepEnum.INITIATE && <OrdersOAInitiate />}

                        {action === OpenAccessOrderStepEnum.REVIEW && <OrdersOAReview />}

                        {action === OpenAccessOrderStepEnum.PAYMENT && <OrdersOAPayment />}

                        {action === OpenAccessOrderStepEnum.CONFIRMATION && (
                            <OrdersOAConfirmation onFinish={onConfirmSubstep} />
                        )}
                    </>
                )}
            </Layout>
        </div>
    );
}

export { OpenAccessOrderStepEnum };
export default compose(
    withCodes2(ID.ORDER_PANELS, ID.BUTTONS),
    withConfirmLeaving,
    OpenAccessOrderContext.withProvider,
)(OrdersOA);
